import { UserDoc, UserWhole } from 'lib/interfaces/database/user';
import _ from 'lodash';
import { UsersService } from 'services/users';
import { create } from 'zustand';

interface State {
  data: UserWhole[];
}

interface Actions {
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<UserDoc>) => Promise<boolean>;
  readonly update: (id: string, v: Partial<UserDoc>) => Promise<boolean>;
}

interface Store extends State, Actions {}

const useUsersStore = create<Store>((set, get) => {
  const service = UsersService.getInstance();

  return {
    data: [],

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.search({});

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      const record = await service.create(v);

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },
  };
});

export default useUsersStore;
